import axios from "axios";
import { useAsyncData, useRoute } from "nuxt/app";
import Header from "../cmsComponents/Header/Header.vue";
import Footer from "../cmsComponents/Footer/Footer.vue";
import TitleBlock from "../cmsComponents/TitleBlock/TitleBlock.vue";
import SectionWrapper from "../cmsComponents/SectionWrapper/SectionWrapper.vue";
import RichContentBlock from "../cmsComponents/RichContentBlock/RichContentBlock.vue";
import BannersList from "../cmsComponents/BannersList/BannersList.vue";
import CardsList from "../cmsComponents/CardsList/CardsList.vue";
import HtmlContainer from "../cmsComponents/HtmlContainer/HtmlContainer.vue";
import FaqAndDocs from "../cmsComponents/FaqAndDocs/FaqAndDocs.vue";
import Legal from "../cmsComponents/Legal/Legal.vue";
import HeroBanner from "../cmsComponents/HeroBanner/HeroBanner.vue";
import Tabs from "../cmsComponents/Tabs/Tabs.vue";
import Steps from "../cmsComponents/Steps/Steps.vue";
import LeadForm from "../cmsComponents/LeadForm/LeadForm.vue";
import ProductList from "../cmsComponents/ProductList/ProductList.vue";
import { buildConfiguration } from "../utils/buildConfiguration.js";
import { useRuntimeConfig } from "#imports";
export async function useBrxm() {
  const config = useRuntimeConfig();
  const route = useRoute();
  const endpoint = config.public.NUXT_APP_BRXM_ENDPOINT ?? "";
  const baseUrl = config.public.BASE_URL !== "/" ? config.public.BASE_URL ?? "" : "";
  const hasMultiTenantSupport = config.public.NUXT_APP_BR_MULTI_TENANT_SUPPORT === "true";
  const mapping = {
    Header,
    Footer,
    TitleBlock,
    SectionWrapper,
    LeadForm,
    RichContentBlock,
    BannersList,
    CardsList,
    HtmlContainer,
    FaqAndDocs,
    Legal,
    HeroBanner,
    Tabs,
    Steps,
    ProductList
  };
  const configuration = {
    ...buildConfiguration(`${route.fullPath}`, axios, baseUrl, endpoint, hasMultiTenantSupport)
  };
  const { data } = await useAsyncData(async (context) => {
    return { page: context?.ssrContext?.event?.node?.req?.pageBody };
  });
  const page = data.value?.page;
  return { mapping, configuration, page };
}
